// internationalization
import type { TFunction } from 'i18next';

// shared components
import type { DanishAddressFieldValue } from '@/components/ui/form';

// libraries
import { z } from 'zod';

export function createEditGatewayFormSchema(t: TFunction) {
  return z.object({
    name: z.string().min(1, t('input.required', { ns: 'validation' })),
    description: z.string(),
    address: z.custom<DanishAddressFieldValue>(),
  });
}

export type EditGatewayFormValues = z.infer<
  ReturnType<typeof createEditGatewayFormSchema>
>;
